import { createAsyncThunk } from "@reduxjs/toolkit";
import server from "../middleware/interceptor";


interface LoginPayload {
  username: string  ; 
  password : string ; 
}

export interface SignUpPayload {
  name: string;
  email: string;
  password: string;
  confirm_password: string;
  institution: string;
  grade: number | null;
  birth_date: string | null;
}
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (values : LoginPayload, { rejectWithValue }) => {
    try {
      const response = await server.post("/auth/login", values , {
        headers : {
          "Content-Type": "application/x-www-form-urlencoded",
        }
      });
      return response.data; // Return user data from API response
    } catch (error : any) {
      return rejectWithValue(error.response?.data || "Login failed"); 
    }
  }
); 

export const signUpPostCall = createAsyncThunk(
  "auth/signup",
  async (user: SignUpPayload, { rejectWithValue }) => {
    try {
      const response = await server.post("/auth/signup", user , {
        headers : {
          "Content-Type" : "application/json", 
        }
      });
      return response.data ;   
    } catch (error: any) {
      return rejectWithValue(error.response.data || "Sign up failed ")
    }
  }
);

export const sendForgotPasswordRequest = createAsyncThunk(
  "forgotPassword/sendForgotPasswordRequest",
  async (email : Object, { rejectWithValue }) => {
    try {
      const response = await server.post("/auth/forgot-password",  email );
      return response.data ;
    } catch (error : any ) {
      return rejectWithValue(error.response.data  || "Something went wrong");
    }
  }
);
export const resetPassword = createAsyncThunk(
  "auth/resetPassword" , 
  async (credentialsValue  : any ,  {rejectWithValue}) => {
    try{
      const response = await server.post("/auth/reset-password" , credentialsValue , {
        headers : {
          "Content-Type" : "application/json" , 
        }
      }); 
      return response.data ;
    }catch(error : any) {
      return rejectWithValue(error.response.data || "Something went wrong")
    }
  }
);

export const changePassword = createAsyncThunk(
  "auth/changePassword" , 
  async (password  : any ,  {rejectWithValue}) => {
    try{
      const response = await server.post("/auth/change-password" , password , {
        headers : {
          "Content-Type" : "application/json" , 
        }
      });
      return response.data ;
    }catch(error : any) {
      return rejectWithValue(error.response.data || "Something went wrong")
    }
  }
);

export const logoutAPI = createAsyncThunk(
  "auth/logout" , 
  async () => {
    try{
      const response = await server.post("/auth/logout" , {
        headers : {
          "Content-Type" : "application/json" , 
        }
      });
      return response.data ;
    }catch(error : any) {
      return (error.response.data || "Something went wrong")
    }
  }
);
